import ReactDOM from 'react-dom';
import React from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import App from './App'; // Adjust the import path as necessary
import './index.css'; // Or './App.css' if named differently
import { createRoot } from 'react-dom/client';

const root = createRoot(document.getElementById('root'));
root.render(<App />);
